module.exports = __webpack_public_path__ + "media/images/icons/pen-83fa775b8d9dacd6edd26c86ce922fe8.svg";